import React, { useEffect } from 'react';
import { Metadata } from '@thd-olt-component-react/metadata';
import { useParams } from '@thd-olt-component-react/router';
import { GiftCardsInformation } from '@thd-olt-component-react/gift-cards-information';
import CardBreadcrumbs from '../components/pip/CardBreadcrumbs';

export const HomeV2 = () => {
  const { name, productLineId, configurationId } = useParams();
  const productInfo2 = {
    productName: name,
    productLineId,
    configurationId
  }

  const metaData = {
    alternateUrlEn: 'https://www.homedepot.com/gift-cards/p/',
    alternateUrlEnCa: 'https://www.homedepot.ca/en/home/gift-cards.html',
    alternateUrlFrCa: 'https://www.homedepot.ca/fr/accueil/cartes-cadeaux.html',
    canonicalURL: 'pathname',
    description: 'Shop Home Depot gift cards online and get more done! Whether you need a Home Depot gift card, '
    + 'or one of the many specialty gift cards we stock, we have you covered.',
    facebookAdmins: '100005416960152',
    siteName: 'The Home Depot',
    title: 'Buy Gift Card',
    type: 'Content',
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }, 500)
  }, []);

  return (
    <>
      <Metadata data={metaData} />
      <div className="sui-max-w-screen-2xl sui-m-auto sui-my-6" data-testid="pip-container">
        <div className="sui-ml-3 sui-mt-0 sui-mb-2" data-testid="breadcrumbs-pip">
          <CardBreadcrumbs />
        </div>
        {/* eslint-disable react/jsx-props-no-spreading */}
        <GiftCardsInformation {...productInfo2} />
      </div>
    </>
  );
};

HomeV2.displayName = 'GiftCardsPage';
